<script>
	var pos = 0;
	var opened_tooltip = true;
	var opened_imprint = false;

	function onClickMilestoneButton(id) {
		if (id == pos) {
			opened_tooltip = !opened_tooltip;
		} else {
			pos = id;
			opened_tooltip = true;
		}
	}

	function onClickImprintButton() {
		opened_imprint = true;
	}

	function onClickImprintCloseButton() {
		opened_imprint = false;
	}
</script>

<main>
	<section>
		<header>
			<img src="assets/img/svg/logo.svg" alt="Logo of AETHERNIA - Strategy Card Game" />
		</header>

		<script>
			kofiWidgetOverlay.draw('aetherniagame', {
				'type': 'floating-chat',
				'floating-chat.donateButton.text': 'Support me',
				'floating-chat.donateButton.background-color': '#00b9fe',
				'floating-chat.donateButton.text-color': '#fff'
			});
		</script>

		<div class={`milestones milestones--pos-${pos} ${opened_tooltip ? 'milestones-milestone--tooltip-open' : ''}`} id='milestones'>
			<div class="milestones-content">
				<div class={`milestones-milestone ${(pos == 0) ? 'milestones-milestone--active' : ''}`}>
					<button type="button" id="milestone-0" on:click={(e) => onClickMilestoneButton(0)}>
						<div class="tooltip-title">
							<h3>Tech Demo #1</h3>
							<h4><span class="text-vivid">In Development</span> - Release July 2022</h4>
						</div>
						<div class="tooltip-info">
							<h5>Core Features</h5>
							<ul>
								<li>First playable build of the game <i>... noice!</i></li>
								<li><i>Quick Match</i> mode with pre-defined decks and maps against AI</li>
							</ul>
						</div>
					</button>
				</div>
				<div class={`milestones-milestone milestones-milestone--upcoming ${(pos == 1) ? 'milestones-milestone--active' : ''}`}>
					<button type="button" id="milestone-1" on:click={(e) => onClickMilestoneButton(1)}>
						<div class="tooltip-title">
							<h3>Tech Demo #2</h3>
							<h4><span class="text-faded">No release date yet</span></h4>
						</div>
						<div class="tooltip-info">
							<h5>Core Features</h5>
							<ul>
								<li>Map Editor and Deck Editor</li>
								<li><i>Custom Match</i> mode for custom decks and maps</li>
							</ul>
						</div>
					</button>
				</div>
				<div class={`milestones-milestone milestones-milestone--upcoming ${(pos == 2) ? 'milestones-milestone--active' : ''}`}>
					<button type="button" id="milestone-2" on:click={(e) => onClickMilestoneButton(2)}>
						<div class="tooltip-title">
							<h3>???</h3>
							<h4><span class="text-faded">No release date yet</span></h4>
						</div>
						<div class="tooltip-info">
							<h5>Core Features</h5>
							<ul>
								<li>Singleplayer scenario as introduction to story mode</li>
								<li>Several new monster types, cards and decks</li>
							</ul>
						</div>
					</button>
				</div>
			</div>
		</div>

		<div class="discord">
			<p>Join the Discord server to stay updated about the game and its development progress. Get behind-the-scenes impressions, exclusive image and video material and discuss further game topics.</p>
			<a href='https://discord.gg/cJrW663bHA' class="button button--discord" target="_blank">
				Join Discord Server
			</a>
		</div>
	</section>
	<footer>
		<div>
			<a href='https://instagram.com/aetherniagame'>Instagram</a>
			<button type='button' id="button--imprint" on:click={(e) => onClickImprintButton()}>Imprint</button>
			<span>&copy; 2022</span>
		</div>
	</footer>

	<article class={`popup ${opened_imprint ? 'popup--visible' : ''}`} id="popup-imprint">
		<button type="button" class="button button--no-type button--close" id='button--imprint-close' on:click={(e) => onClickImprintCloseButton()}>
			<span>Close</span>
		</button>
		<div class="popup-content">
			<h3>Imprint</h3>
			<p>
				Aethernia<br />
				aetherniagame [at] gmail.com
			</p>
		</div>
	</article>

	
</main>

<style>

	article.popup {
		position: absolute;
		padding: 2rem;
		opacity: 0;
		pointer-events: none;
		transition: all 0.2s ease-out;
		right: 0;
		top: 0;
	}

	article.popup--visible {
		opacity: 1;
		pointer-events: all;
	}

	.popup-content {
		width: 100%;
		height: 100%;
		background-color: rgba(21, 23, 34, 0.95);
		border-radius: 4rem;
		padding: 5rem;
		padding-right: 10rem;
	}

	.popup-content h3 {
		color: #17ce8b;
		margin-bottom: 1rem;
		font-size: 2.0rem;
	}

	.popup-content p {
		font-size: 1.6rem;
	}

	main {
		background-color: #11243d;
		background-image: url('../assets/img/background-screen.jpg');
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;

		max-width: 100%;
		min-height: 100%;

		display: flex;
		flex-direction: column;

		overflow-x: hidden;
	}

	footer {
		display: flex;

		justify-content: center;
		align-items: center;
		padding: 1.5rem;
	}

	footer div {
		text-align: right;
		width: 100%;
	}

	footer div * {
		opacity: 0.5;
		font-size: 1.4rem;
		margin: 0 1rem;
	}

	footer div *:last-child {
		opacity: 0.33;
	}

	section {
		height: 100%;

		display: flex;
		flex-direction: column;
		align-items: center;
		flex-grow: 1;
		justify-content: space-evenly;
	}

	header {
		margin-top: 5rem;
	}

	header img {
		display: block;
		margin: 0 auto;
		width: 68rem;
		max-width: 80%;
	}

	.milestones {
		position: relative;
		transition: all 0.1s ease-out;
		margin: 7rem 0 14rem 0;
	}

	.milestones--pos-0 {
		transform: translateX(27rem);
	}

	.milestones--pos-1 {
		transform: translateX(0rem);
	}

	.milestones--pos-2 {
		transform: translateX(-27rem);
	}

	@media screen and (max-width: 959px) {
		.milestones--pos-0 {
			transform: translateX(12rem);
		}

		.milestones--pos-1 {
			transform: translateX(0rem);
		}

		.milestones--pos-2 {
			transform: translateX(-12rem);
		}
	}

	.milestones-content {
		display: flex;
		flex-direction: row;
		justify-content: center;
		position: relative;
		padding-left: 15rem;
	}

	.milestones-milestone {
		background-color: transparent;
		background-image: url('../assets/img/milestone-bg.png');
		background-position: center;
		background-repeat: no-repeat;

		width: 7.6rem;
		height: 7.6rem;
		margin-right: 20rem;

		position: relative;
	}

	.milestones-milestone::after {
		content: '';
		display: block;

		background-color: #1b1e2c;
		
		min-width: 20rem;
		height: 0.6rem;

		position: absolute;
		left: 100%;
		top: calc(50% - 0.3rem);

		border-radius: 0.6rem;
	}

	.milestones-milestone:last-child {
		margin-right: 15rem;
	}

	.milestones-milestone:last-child::after {
		background-color: transparent;
		background: linear-gradient(90deg, rgba(27, 30, 44, 1.0), rgba(27, 30, 44, 0.0));
		min-width: 15rem;
	}

	.milestones-milestone button {
		position: relative;

		display: flex;

		justify-content: center;
		align-items: center;

		margin: 0;
		padding: 0;
		border: 0;

		background-color: transparent;
		background-image: url('../assets/img/early-button-default.png');
		background-position: center;
		background-repeat: no-repeat;

		width: 7.6rem;
		height: 7.6rem;

		opacity: 0.5;
		transform: scale(0.9);

		transition: all 0.1s ease-out;
	}

	.milestones-milestone.milestones-milestone--upcoming button {
		background-image: url('../assets/img/milestone-button-upcoming.png');
	}

	.milestones-milestone.milestones-milestone--active button {
		opacity: 1.0;
		transform: scale(1.0);
	}

	.milestones-milestone button > * {
		pointer-events: none;

		opacity: 0.0;
		transform: scale(0.0);

		transition: all 0.1s ease-out;
	}

	.milestones-milestone.milestones-milestone--active button .tooltip-title {
		opacity: 1.0;
		transform: scale(1.0);
	}

	.milestones-milestone--tooltip-open .milestones-milestone.milestones-milestone--active button > .tooltip-info {
		opacity: 1.0;
		transform: scale(1.0);
	}

	.milestones-milestone button .tooltip-title {
		display: flex;
		flex-direction: column;

		justify-content: center;
		align-items: center;

		background-color: transparent;
		background-image: url('../assets/img/milestone-title-bg.png');
		background-position: center;
		background-repeat: repeat-x;
		
		height: 6.4rem;

		position: absolute;

		bottom: 100%;

		transform-origin: bottom center;

		margin-top: -15rem;
	}

	.milestones-milestone button .tooltip-title h3 {
		display: block;

		padding: 0;
		margin: 0;

		font-size: 1.6rem;
		font-weight: bold;
		
		white-space: nowrap;
	}

	.milestones-milestone button .tooltip-title h4  {
		display: inline-block;

		padding: 0;
		margin: 0;

		font-size: 1.4rem;
		font-weight: normal;
		
		white-space: nowrap;
		margin-top: -0.5rem;
	}

	.milestones-milestone button .tooltip-title::before {
		content: '';
		display: block;

		background-color: transparent;
		background-image: url('../assets/img/milestone-title-bg-left.png');
		background-position: center;
		background-repeat: no-repeat;
		
		width: 2.8rem;
		height: 6.4rem;

		position: absolute;
		top: 0;
		right: 100%;
	}

	.milestones-milestone button .tooltip-title::after {
		content: '';
		display: block;

		background-color: transparent;
		background-image: url('../assets/img/milestone-title-bg-right.png');
		background-position: center;
		background-repeat: no-repeat;
		
		width: 2.8rem;
		height: 6.4rem;

		position: absolute;
		top: 0;
		left: 100%;
	}

	.milestones-milestone button .tooltip-info {
		display: flex;
		flex-direction: column;

		justify-content: center;
		align-items: center;

		background-color: rgba(27, 33, 40, 0.75);
		background-image: url('../assets/img/tooltip-info-bg.png');
		background-position: bottom;
		background-repeat: repeat-x;

		position: absolute;

		transform-origin: top center;

		border-radius: 2rem;
		min-width: 10rem;

		top: 100%;

		margin-top: 1.5rem;

		padding: 1.5rem 1.75rem 1.75rem;
	}

	.milestones-milestone button .tooltip-info > * {
		white-space: nowrap;

		text-align: left;
	}

	.milestones-milestone button .tooltip-info h5 {
		font-size: 1.4rem;
		text-transform: uppercase;
		color: #17ce8b;

		width: 100%;
		text-align: left;
	}

	.milestones-milestone button .tooltip-info ul {
		list-style-type: disc;
		padding-left: 1.5rem;
	}

	.milestones-milestone button .tooltip-info li {
		font-size: 1.4rem;

		width: 100%;
		text-align: left;
	}

	.milestones-milestone button .tooltip-info::before {
		content: '';
		display: block;

		background-color: transparent;
		background-image: url('../assets/img/tooltip-info-tip.png');
		background-position: center;
		background-repeat: no-repeat;
		
		width: 5.1rem;
		height: 1.2rem;

		position: absolute;

		bottom: 100%;
	}

	.milestones-milestone button:hover {
		opacity: 1.0;
		transform: scale(1.0);
	}
	/*
	.milestones-milestone button:hover > * {
		opacity: 1.0;
		transform: scale(1.0);

		transition: all 0.1s ease-out;
	} */

	@media screen and (max-width: 959px) {
		.milestones-content {
			padding-left: 5rem;
		}

		.milestones-milestone {
			margin-right: 5rem;
		}

		.milestones-milestone::after {
			min-width: 5rem;
		}

		.milestones-milestone:last-child {
			margin-right: 5rem;
		}

		.milestones-milestone:last-child::after {
			min-width: 5rem;
		}
	}

	.text-vivid {
		font-weight: bold;
		color: #17ce8b;
	}

	.text-faded {
		opacity: 0.5;
	}

	.button {
		font-weight: bold;
		font-size: 2.2rem;
		white-space: nowrap;

		display: flex;

		justify-content: flex-start;
		align-items: center;

		background-color: transparent;
		background-image: url('../assets/img/button-bg.png');
		background-position: center;
		background-repeat: no-repeat;

		width: 28.4rem;
		height: 6.4rem;

		position: relative;

		padding: 0 2.5rem;
	}

	.button {
		transform: scale(0.9);
		transition: all 0.1s ease-out;
	}

	.button:hover {
		transform: scale(1.0);
	}

	.button::after {
		content: '';
		display: block;

		width: 6.4rem;
		height: 6.4rem;

		background-color: transparent;
		background-image: url('../assets/img/discord-button-default.png');
		background-position: center;
		background-repeat: no-repeat;

		position: absolute;
		right: 0.3rem;

		opacity: 0.5;
		transform: scale(0.9);
		transition: all 0.1s ease-out;
	}

	.button--discord::after {
		background-image: url('../assets/img/discord-button-default.png');
	}

	.button--close::after {
		background-image: url('../assets/img/close-button-default.png');
	}

	.button:hover::after {
		opacity: 1.0;
		transform: scale(1.0);
	}

	.discord {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
	}

	.discord p {
		margin-bottom: 1.5rem;
		font-size: 1.6rem;
		width: 50rem;
		max-width: 80%;
		text-align: center;
		text-shadow: 0 0.2rem 0 rgba(7, 13, 20, 0.75);
	}

	.button--no-type {
		background-color: transparent;
		background-image: url('../assets/img/milestone-bg.png');
		background-position: center;
		background-repeat: no-repeat;

		width: 7.6rem;
		height: 7.6rem;
	}

	.button--no-type span {
		display: none;
	}

	.button--no-type::after {
		right: unset;
		left: calc(50% - 3.2rem);
	}

	#button--imprint-close {
		position: absolute;
		top: 3rem;
		right: 3rem;
		opacity: 1;
	}

	#button--imprint-close::after {
		opacity: 1;
	}

</style>